<template>
  <div
    v-editable="blok"
    class="MultiColumnBlock layout-container"
    :class="[desktopWidth('full'), blockPaddingTop('md'), blockPaddingBottom('md')]"
  >
    <div
      v-if="columnOne.length"
      class="grid"
      :class="[
        blok.verticalCenter || 'items-start', {
        'grid-cols-1 desk:grid-cols-[repeat(auto-fit,_minmax(150px,_1fr))]': blok.design === 'default',
        'grid-cols-1 desk:grid-cols-2': blok.design === 'tiled',
        'gap-0': blok.gap === 'none',
        'gap-16 desk:gap-24': blok.gap === 'sm',
        'gap-24 desk:gap-32': blok.gap === 'md',
        'gap-32 desk:gap-40': blok.gap === 'lg'
      }]"
    >
      <StoryblokComponent
        v-for="(blokItem, index) in columnOne"
        :key="blokItem._uid || index"
        :blok="blokItem"
        :class="{
          'p-0': blok.padding === 'none',
          'p-16': blok.padding === 'sm',
          'p-24': blok.padding === 'md',
          'p-32': blok.padding === 'lg',
          'bg-bg-subtle': blok.backgroundColor === 'subtle',
          'bg-bg-secondary': blok.backgroundColor === 'secondary',
          'bg-bg-accenture': blok.backgroundColor === 'accenture',
        }"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import useVisualAppearancePlugin from '~/composables/useVisualAppearancePlugin';

type MultiColumnBlockType = {
  _uid: string;
  columnOne?: any[];
  gap: 'none' | 'sm' | 'md' | 'lg';
  padding: 'none' | 'sm' | 'md' | 'lg';
  backgroundColor: 'none' | 'subtle' | 'secondary' | 'accenture';
  design: 'default' | 'tiled';
  verticalCenter?: 'items-center' | 'items-start' | 'items-end'

};

const props = defineProps<{ blok: MultiColumnBlockType }>();

// Normalize columnOne to always be an array
const columnOne = computed(() => props.blok.columnOne || []);

const { desktopWidth, blockPaddingTop, blockPaddingBottom } = useVisualAppearancePlugin(props);
</script>
